// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__goGbE","title":"Header_title__1uxxH","side":"Header_side__3WyX5"};